var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pass-1{fill:#6ec092;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pass_back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "pass-1",
    d: "M350,17.6V2.4A2.4,2.4,0,0,0,347.6,0H2.4A2.4,2.4,0,0,0,0,2.4V17.6s9.9,4.1,9.9,17.9S0,53.4,0,53.4V68.6A2.4,2.4,0,0,0,2.4,71H347.6a2.4,2.4,0,0,0,2.4-2.4V53.4s-9.9-4.1-9.9-17.9S350,17.6,350,17.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.4,15.2h3.9c2.4,0,3.6,1.3,3.6,3.8v2.7a3.4,3.4,0,0,1-2.6,3.6,4.4,4.4,0,0,1-1.8.2h-.2V33H33.4ZM36.3,18v4.7h1a.8.8,0,0,0,.6-.9V19c0-.7-.3-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.5,26.6l.8,6.4h-3l-.5-3.7H44.7L44.2,33h-3l.8-6.3,1.8-11.5h3.9Zm-3-.1-.8-5.4L45,26.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.7,18.7c0-2.5,1.3-3.8,3.8-3.8s3.9,1.3,3.9,3.8v2.6h-3V18.7c0-.6-.3-1-.9-1h0c-.6,0-.8.4-.8,1v1.6c0,.8.7,1.7,2.2,2.8a4.8,4.8,0,0,1,2.5,4.1v2.3c0,2.5-1.3,3.8-3.9,3.8s-3.8-1.3-3.8-3.8V26.9h3v2.6c0,.6.3,1,.8,1s.9-.4.9-1v-2c0-.8-.7-1.8-2.3-2.9a4.9,4.9,0,0,1-2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.4,18.7c0-2.5,1.2-3.8,3.8-3.8s3.9,1.3,3.9,3.8v2.6h-3V18.7c0-.6-.3-1-.9-1h0c-.6,0-.9.4-.9,1v1.6c0,.8.8,1.7,2.3,2.8a4.8,4.8,0,0,1,2.5,4.1v2.3c0,2.5-1.3,3.8-3.9,3.8s-3.8-1.3-3.8-3.8V26.9h2.9v2.6c0,.6.3,1,.9,1s.9-.4.9-1v-2c0-.8-.8-1.8-2.3-2.9a4.9,4.9,0,0,1-2.4-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.9,51.4q0,3.9-3.9,3.9c-2.5,0-3.8-1.3-3.8-3.9V40.7c0-2.6,1.3-3.9,3.8-3.9s3.9,1.3,3.9,3.9v2.5h-3V40.7c0-.7-.3-1-.9-1h0c-.6,0-.8.3-.8,1V51.4c0,.7.3,1,.8,1s.9-.3.9-1V48.9h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.5,51.4q0,3.9-3.9,3.9c-2.5,0-3.8-1.3-3.8-3.9V40.7c0-2.6,1.3-3.9,3.8-3.9s3.9,1.3,3.9,3.9Zm-3-10.7c0-.7-.3-1-.9-1h0c-.6,0-.9.3-.9,1V51.4c0,.7.3,1,.9,1s.9-.3.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.3,51.4q0,3.9-3.9,3.9t-3.9-3.9V37.1h3V51.4c0,.7.3,1,.9,1s.9-.3.9-1V37.1h3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.5,37.1h3.9Q70,37.1,70,41v2.6a3.6,3.6,0,0,1-2.6,3.7l-1.7.2h-.2V55h-3Zm3,2.9v4.6h.9a1,1,0,0,0,.6-1V41c0-.7-.3-1-.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.4,51.4q0,3.9-3.9,3.9c-2.5,0-3.8-1.3-3.8-3.9V40.7c0-2.6,1.3-3.9,3.8-3.9s3.9,1.3,3.9,3.9Zm-3-10.7c0-.7-.3-1-.9-1h0c-.6,0-.8.3-.8,1V51.4c0,.7.3,1,.8,1s.9-.3.9-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.5,37.1h3l2,8.8V37.1h2.8V55h-3l-1.9-8.6V55H81.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.6,56.8a1,1,0,0,1-1-1V15.2a1,1,0,0,1,1-1,1.1,1.1,0,0,1,1,1V55.8A1.1,1.1,0,0,1,103.6,56.8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassBack);
export default __webpack_public_path__ + "static/media/pass_back.eed42907e6bc3fad7f4e369239ed18ad.svg";
export { ForwardRef as ReactComponent };